module.exports = __webpack_public_path__ + "static/Creator 13 - @Alyttleton-1a530c71f503d7c126f3afb2a5eb8e60.png";